import styled from 'styled-components';
import { device } from '../../../styles/breakpoints';
import { BodyText1, BodyText2, BodyText3, SubTitle } from '../../atoms/Fonts';

export const ForgotPasswordStepTwoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Subheader = styled(BodyText3)`
  margin-top: 8px;
  color: ${(props) => props.theme.colors.text.default};
`;

export const EmailLabel = styled(BodyText2)`
  color: ${(props) => props.theme.colors.theme.neutralDark.dark};
  margin-top: 8px;
`;

export const FooterWrapper = styled.div`
  margin: 80px 0 24px 0;
  display: flex;
  align-items: center;

  @media ${device.mobile} {
    flex-direction: column;
  }
`;

export const DidntReceiveLabel = styled(BodyText1)`
  margin: 0;
  margin-right: 8px;
  color: ${(props) => props.theme.colors.text.default};

  @media ${device.mobile} {
    margin-bottom: 8px;
  }
`;

export const LogoWrapper = styled.div`
  @media ${device.mobile} {
  }
`;
